// converts iPhone X size in pixels to vwx device size
const vwx = (px: number): number => {
  if (typeof window !== 'undefined' && typeof window.innerWidth === 'number') {
    const vw = window.innerWidth / 100

    return 0.2667 * px * vw
  }

  return px
}


export default vwx
